<template>
  <div class="floating-widget" :class="{ 'floating-widget--visible': showBackToTop || true }">
    <!-- 电话咨询按钮 -->
    <div class="floating-widget__item floating-widget__item--phone" title="一键拨打电话">
      <div class="icon">📞</div>
      <div class="phone-panel">
        <p class="phone-panel__title">咨询专线</p>
        <div v-for="(c, idx) in company.contacts" :key="idx" class="phone-panel__item">
          <p class="phone-panel__contact">{{ c.name }}</p>
          <a :href="'tel:' + c.phone" class="phone-panel__num">{{ c.phone }}</a>
        </div>
      </div>
    </div>

    <!-- 返回顶部按钮 -->
    <div
      class="floating-widget__item floating-widget__item--top"
      v-show="showBackToTop"
      @click="scrollToTop"
      title="返回顶部"
    >
      <div class="icon">▲</div>
      <span class="tooltip-text">返回顶部</span>
    </div>
  </div>
</template>

<script>
import { COMPANY } from '@/constants/company'

export default {
  name: 'FloatingWidget',
  data () {
    return {
      company: COMPANY,
      showBackToTop: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.floating-widget {
  position: fixed;
  right: 1.5rem;
  bottom: 6rem;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  opacity: 0;
  transform: translateX(20px);
  animation: slide-in-fade 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;

  &--visible {
    opacity: 1;
    transform: translateX(0);
  }

  &__item {
    width: 3.25rem;
    height: 3.25rem;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    position: relative;
    border: 1px solid var(--color-border);
    color: var(--color-text);
    text-decoration: none;

    .icon {
      font-size: 1.25rem;
    }

    &:hover {
      background: var(--color-primary);
      color: #fff;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(16, 185, 129, 0.3);
      border-color: var(--color-primary);

      .tooltip-text {
        opacity: 1;
        transform: translateX(0);
        pointer-events: auto;
      }

      .phone-panel {
        opacity: 1;
        transform: translateX(0);
        pointer-events: auto;
      }
    }

    &--phone {
      background: var(--color-primary);
      color: #fff;
      border-color: var(--color-primary);

      &:hover {
        background: var(--color-accent);
        border-color: var(--color-accent);
        box-shadow: 0 6px 20px rgba(245, 158, 11, 0.3);
      }
    }
  }

  .tooltip-text {
    position: absolute;
    right: 4rem;
    background: var(--color-dark);
    color: #fff;
    padding: 0.5rem 0.875rem;
    border-radius: var(--radius-sm);
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
    box-shadow: var(--shadow-md);
    opacity: 0;
    transform: translateX(10px);
    transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      right: -4px;
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
      width: 8px;
      height: 8px;
      background: var(--color-dark);
    }
  }

  .phone-panel {
    position: absolute;
    right: 4rem;
    background: #fff;
    border: 1px solid var(--color-border);
    padding: 1rem 1.25rem;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-lg);
    opacity: 0;
    transform: translateX(10px);
    transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    pointer-events: none;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    text-align: left;
    min-width: 14rem;

    &::after {
      content: '';
      position: absolute;
      right: -6px;
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
      width: 10px;
      height: 10px;
      background: #fff;
      border-right: 1px solid var(--color-border);
      border-top: 1px solid var(--color-border);
    }

    &__title {
      font-size: 0.8rem;
      color: var(--color-text-light);
      margin: 0 0 0.5rem 0;
      font-weight: 600;
      border-bottom: 1px solid var(--color-border);
      padding-bottom: 0.25rem;
    }

    &__item {
      display: flex;
      flex-direction: column;
      gap: 0.1rem;
      text-align: left;
      &:not(:last-child) {
        border-bottom: 1px dashed var(--color-border);
        padding-bottom: 0.5rem;
        margin-bottom: 0.5rem;
      }
    }

    &__num {
      font-size: 1.15rem;
      font-weight: 700;
      color: var(--color-primary-dark) !important;
      margin: 0;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: var(--color-primary) !important;
        text-decoration: underline;
      }
    }

    &__contact {
      font-size: 0.85rem;
      color: var(--color-text-muted);
      margin: 0;
      font-weight: 600;
    }
  }
}

@keyframes slide-in-fade {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 576px) {
  .floating-widget {
    right: 1rem;
    bottom: 4rem;

    &__item {
      width: 2.75rem;
      height: 2.75rem;

      .icon {
        font-size: 1.1rem;
      }
    }

    .phone-panel, .tooltip-text {
      display: none !important; // Hide hover panels on mobile
    }
  }
}
</style>
